import { render, staticRenderFns } from "./Closed.vue?vue&type=template&id=44f9e1f3&scoped=true"
import script from "./Closed.vue?vue&type=script&lang=js"
export * from "./Closed.vue?vue&type=script&lang=js"
import style0 from "./Closed.vue?vue&type=style&index=0&id=44f9e1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f9e1f3",
  null
  
)

export default component.exports